/*
 * @Author: Nie Wie
 * @Date: 2020-02-21 14:01:51
 * @LastEditors  : Chen Zhen
 * @LastEditTime : 2020-02-24 00:52:44
 * @Description: z
 */
import Vue from 'vue'
import Vuex from 'vuex'

import common from './common'
import page from './page'
import map from './map'
import work from './work'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    common,
    page,
    map,
    work,
  },
})
